import { useState, useEffect } from 'react';
import { collection, onSnapshot, addDoc, doc, deleteDoc } from 'firebase/firestore';
import { db } from './firebase';

export function useTags() {
  const [tags, setTags] = useState([]);
  useEffect(() => onSnapshot(collection(db, 'crm_tags'), s => setTags(s.docs.map(d => ({ id: d.id, ...d.data() })))), []);

  const addTag = async (name, color) => {
    const exists = tags.find(t => t.name.toLowerCase() === name.toLowerCase());
    if (exists) return exists;
    const ref = await addDoc(collection(db, 'crm_tags'), { name, color });
    return { id: ref.id, name, color };
  };

  const removeTag = async (id) => {
    await deleteDoc(doc(db, 'crm_tags', id));
  };

  const getColor = (name) => {
    const t = tags.find(t => t.name === name);
    return t?.color || '#94a3b8';
  };

  return { tags, addTag, removeTag, getColor };
}

export const TAG_COLORS = [
  '#ef4444', '#f97316', '#f59e0b', '#84cc16', '#10b981',
  '#06b6d4', '#3b82f6', '#6366f1', '#a855f7', '#ec4899',
  '#78716c', '#94a3b8'
];